/*
 * @Author: 田鑫
 * @Date: 2022-01-07 11:22:39
 * @LastEditors: 田鑫
 * @LastEditTime: 2022-01-07 11:22:40
 * @Description:
 */

import ossUploader from "./main.vue";

/* istanbul ignore next */
ossUploader.install = function(Vue) {
  Vue.component(ossUploader.name, ossUploader);
};

export default ossUploader;
